import { useMutation, useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

import type { Id } from "@convex/_generated/dataModel";

export function useAllowlist() {
  const entries = useQuery(api.emails.listAllowlist) ?? [];
  const addEntry = useMutation(api.emails.addAllowlistEntry);
  const removeEntry = useMutation(api.emails.removeAllowlistEntry);

  return {
    addEntry: async ({ pattern, type }: { pattern: string; type: "address" | "domain" }) => {
      return await addEntry({ pattern, type });
    },
    entries,
    removeEntry: async ({ entryId }: { entryId: Id<"emailAllowlist"> }) => {
      await removeEntry({ entryId });
    },
  };
}
